<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="户型类别"
                    prop="houseName">
                    <Input v-model="info.houseName"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="户型"
                    prop="houseType">
                    <Input v-model="info.houseType"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="状态"
                    prop="saleStatus">
                    <Select v-model="info.saleStatus"
                        transfer
                        placeholder
                        :readonly="readonly">
                        <Option v-for="(item, index) in saleStatusList"
                            :value="item.id"
                            :key="index">{{ item.text }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="售价"
                    prop="price">
                    <input-number v-model="info.price"
                        placeholder
                        :readonly="readonly">
                        <span slot="append">万元/套</span>
                    </input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="建筑面积"
                    prop="buildArea">
                    <input-number v-model="info.buildArea"
                        placeholder
                        :readonly="readonly">
                        <span slot="append">m²</span>
                    </input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="居室"
                    prop="livingRoom">
                    <Select v-model="info.livingRoom"
                        transfer
                        placeholder
                        :readonly="readonly">
                        <Option v-for="(item, index) in livingRoomList"
                            :value="item.id"
                            :key="index">{{ item.text }}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="户型分布"
                    prop="layout">
                    <Input v-model="info.layout"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="主力户型"
                    prop="mainHouse">
                    <i-switch :readonly="readonly"
                        v-model="info.mainHouse"
                        size="large"
                        :true-value="1"
                        :false-value="0">
                        <span slot="open">是</span>
                        <span slot="close">不是</span>
                    </i-switch>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="户型解析"
                    prop="description">
                    <Input :readonly="readonly"
                        v-model="info.description"
                        placeholder
                        type="textarea"
                        :rows="3"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="户型图片"
                    prop="avatar">
                    <preview-upload :readonly="loading"
                        multiple
                        :showName="false"
                        v-model="info.attachments"
                        :format="imgSuffix"></preview-upload>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { houseAdd, houseUpdate, houseView } from '@/api/proj-manager'
import { fileUpdate } from '@/api/sys-oss'
import PreviewUpload from '_c/preview-upload'
import Dict from '@/utils/dict'
export default {
    name: 'FormHouseForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: { PreviewUpload },
    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            imgSuffix: this.$config.upload.imgSuffix,
            info: {
                id: this.id,
                projId: '',
                houseName: '', //户型类别
                houseType: '', //户型
                saleStatus: '', //状态,
                price: '', //售价(万元/套),
                buildArea: '', //建筑面积
                livingRoom: '', //居室,
                layout: '', //户型分布
                mainHouse: 1, //主力户型
                description: '', //户型解析
                attachments: '', //图片
                ver: '' //版本号
            },
            dict: {
                saleStatus: Dict.NULL,
                livingRoom: Dict.NULL
            },
            loading: false
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can("update") : this.$can("add")
        },

        readonly() {
            return this.loading || !this.canSave
        },

        ruleValidate() {
            return {
                houseName: [{ required: true, message: '户型类别必填' }],
                houseType: [{ required: true, message: '户型必填' }],
                saleStatus: [{ required: true, message: '状态必填' }],
                price: [{ required: true, message: '售价必填' }]
            }
        },
        saleStatusList() {
            return this.dict.saleStatus.val()
        },
        livingRoomList() {
            return this.dict.livingRoom.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return houseView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]

        // 预加载
        this.info.projId = this.$route.params.id
        this.loading = true
        
        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)

        this.$modal.beforeEnter(next => {
            Promise.all([
                    Dict.get(['sale_status', 'living_room']),
                    this.fetch()
                ])
                .then(args => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name] || Dict.NULL
                    })
                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name] || '')
                        )
                    }
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.loading = true
                    var formData = Object.assign({}, this.info)
                    if (this.id) {
                        return houseUpdate(formData)
                    } else {
                        return houseAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => (options.closeModal = false))
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped></style>